// asset imports
import "@/assets/scss/argon.scss";

export default {};
